import { IconClose16pxRegular, IconDelete16pxBold, IconDropdown12pxThin, IconDropDownArrow12pxRegular } from "@pionex-web-kit/icons";
import * as React from "react";
import Checkbox from "./../../../Checkbox";
import { IconLoading } from "./../../../Icons/IconLoading";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function getIcons(_ref) {
  var suffixIcon = _ref.suffixIcon,
    clearIcon = _ref.clearIcon,
    menuItemSelectedIcon = _ref.menuItemSelectedIcon,
    removeIcon = _ref.removeIcon,
    loading = _ref.loading,
    multiple = _ref.multiple,
    hasFeedback = _ref.hasFeedback,
    prefixCls = _ref.prefixCls,
    showArrow = _ref.showArrow,
    feedbackIcon = _ref.feedbackIcon;
  // Clear Icon
  var mergedClearIcon = clearIcon;
  if (!clearIcon) {
    mergedClearIcon = /*#__PURE__*/_jsx(IconDelete16pxBold, {
      size: 16
    });
  }

  // Validation Feedback Icon
  var getSuffixIconNode = function getSuffixIconNode(arrowIcon) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [showArrow !== false && arrowIcon, hasFeedback && feedbackIcon]
    });
  };

  // Arrow item icon
  var mergedSuffixIcon = null;
  if (suffixIcon !== undefined) {
    mergedSuffixIcon = getSuffixIconNode(suffixIcon);
  } else if (loading) {
    mergedSuffixIcon = getSuffixIconNode( /*#__PURE__*/_jsx(IconLoading, {
      spin: true,
      size: 14
    }));
  } else {
    var iconCls = "".concat(prefixCls, "-suffix");
    mergedSuffixIcon = function mergedSuffixIcon(_ref2) {
      var open = _ref2.open,
        showSearch = _ref2.showSearch;
      if (open && showSearch) {
        return getSuffixIconNode( /*#__PURE__*/_jsx(IconDropDownArrow12pxRegular, {
          size: 12,
          className: iconCls
        }));
      }
      return getSuffixIconNode( /*#__PURE__*/_jsx(IconDropDownArrow12pxRegular, {
        size: 12,
        className: iconCls
      }));
    };
  }

  // Checked item icon
  var mergedItemIcon = null;
  if (menuItemSelectedIcon !== undefined) {
    mergedItemIcon = menuItemSelectedIcon;
  } else if (multiple) {
    mergedItemIcon = /*#__PURE__*/_jsx(Checkbox, {
      checked: true
    });
  } else {
    mergedItemIcon = /*#__PURE__*/_jsx(IconDropdown12pxThin, {
      size: 12
    });
  }
  var mergedRemoveIcon = null;
  if (removeIcon !== undefined) {
    mergedRemoveIcon = removeIcon;
  } else {
    mergedRemoveIcon = /*#__PURE__*/_jsx(IconClose16pxRegular, {
      size: 10
    });
  }
  return {
    clearIcon: mergedClearIcon,
    suffixIcon: mergedSuffixIcon,
    itemIcon: mergedItemIcon,
    removeIcon: mergedRemoveIcon
  };
}